﻿import { get } from "@/Utils"


function showPrivate() {
  const registerPrivate = get("register-private") as HTMLButtonElement;
  const registerCorporate = get("register-corporate") as HTMLButtonElement;
  if (registerCorporate.disabled) return;

  registerPrivate.classList.add("button--tertiary");
  registerPrivate.classList.remove("button--secondary");
  registerCorporate.classList.add("button--secondary");
  registerCorporate.classList.remove("button--tertiary");
  const isCorporate = (get("IsCorporate") as HTMLInputElement);
  if (isCorporate) {
    (get("IsCorporate") as HTMLInputElement).value = "False";
  }

  const registrationContainer = get("registration-container") as HTMLFormElement;
  registrationContainer?.classList.add("register-private");
  registrationContainer?.classList.remove("register-corporate");
}
function showCorporate() {
  const registerPrivate = get("register-private") as HTMLButtonElement;
  const registerCorporate = get("register-corporate") as HTMLButtonElement;
  if (registerCorporate.disabled) return;

  registerPrivate.classList.remove("button--tertiary");
  registerPrivate.classList.add("button--secondary");
  registerCorporate.classList.remove("button--secondary");
  registerCorporate.classList.add("button--tertiary");
  const isCorporate = (get("IsCorporate") as HTMLInputElement);
  if (isCorporate) {
    (get("IsCorporate") as HTMLInputElement).value = "True";
  }

  const registrationContainer = get("registration-container") as HTMLFormElement;
  registrationContainer?.classList.remove("register-private");
  registrationContainer?.classList.add("register-corporate");
}

export function initToggleButtons() {
  const registerPrivate = get("register-private") as HTMLButtonElement;
  const registerCorporate = get("register-corporate") as HTMLButtonElement;
  registerPrivate?.addEventListener("click", () => showPrivate());
  registerCorporate?.addEventListener("click", () => showCorporate());
}
